(function () {
  const domain = 'jafra.com';
  const links = document.querySelectorAll('a');

  links.forEach((link) => {
    if (!link.href) return;
    
    if (!link.href.includes(domain)) {
      link.setAttribute('target', '_blank');
    }
  })
})();